<template>
  <Plan
    is-highlighted
    title="Pro"
    description="Get all of the free plan plus access to amazing features."
    :price="currentPrice"
    :price-description="`USD per ${interval}`"
    :features="FEATURES"
    :disabled="isDisabled"
    :blocks="blocks"
  >
    <template v-if="!$slots.actions" #actions>
      <slot name="actions" />
    </template>

    <slot v-for="slot in Object.keys($slots)" :slot="slot" :name="slot" />
  </Plan>
</template>

<script>
import { computed } from '@nuxtjs/composition-api';
import Plan from './plan';
import { PRO, PROFILE_PRICES } from './plans';

const FEATURES = [
  {
    title: 'All of the free features',
  },
  {
    title: 'Powerful and versatile link types to keep your content fresh',
  },
  {
    title: 'Manage multiple profiles from a single account',
  },
  {
    title: 'In-depth analytics to track views, clicks, referral, geo and more',
  },
  {
    title:
      'Unlock premium integrations like Opt-in forms, Forms, Tracking Pixels, and more',
  },
  {
    title: 'Add your own domain to your profile for a custom URL',
  },
];

export default {
  components: {
    Plan,
  },

  props: {
    interval: {
      type: String,
      default: 'month',
    },

    profiles: {
      type: Number,
      default: 1,
    },

    blocks: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const currentPrice = computed(() => {
      const profilePrice =
        PROFILE_PRICES[props.interval] *
        Math.min(
          Math.max(props.profiles - PRO.numberOfProfiles, 0),
          PRO.maxProfiles,
        );

      return PRO.price[props.interval] + profilePrice;
    });

    const isDisabled = computed(() => {
      return props.profiles > PRO.maxProfiles;
    });

    return {
      FEATURES,
      currentPrice,
      isDisabled,
    };
  },
};
</script>

<style lang="scss" scoped></style>
